import { createSelector } from 'reselect';

const selectRoute = (state) => state.get('router');

const selectRuntimeConfig = (state) => state.get('runtimeConfig');

const makeSelectLocation = () => createSelector(
  selectRoute,
  (routeState) => routeState.get('location').toJS()
);

const makeSelectRuntimeConfig = () => createSelector(
  selectRuntimeConfig,
  (runtimeState) => runtimeState && runtimeState.toJS()
);

export {
  makeSelectLocation,
  makeSelectRuntimeConfig,
};
